var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrwdmarketIconW(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2295.49,
    height: 301.029,
    viewBox: "0 0 2295.49 301.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.058,
    y1: 1.087,
    x2: 0.675,
    y2: 0.265,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#850143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e40271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.069,
    y1: 0.877,
    x2: 1.323,
    y2: -0.107,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#850143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#e40271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.412,
    y1: -0.5,
    x2: -0.031,
    y2: 0.859,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#850143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#e40271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.606,
    y1: 1.37,
    x2: -0.093,
    y2: -0.067,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.704,
    y1: -0.17,
    x2: 1.294,
    y2: 0.95,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    stopColor: "#850143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e40271",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#850143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.065,
    stopColor: "#910149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#a30151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#ae0156"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#b10158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#aa0155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#97014c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#850143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.295,
    y1: -0.021,
    x2: 0.495,
    y2: 0.626,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(6789.228 -3686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(-6789.228 3686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M246.919,122.421a27.208,27.208,0,0,0-8.36-3.009,38.85,38.85,0,0,0-12.112-.152,33.676,33.676,0,0,0-12.826,4.647,41.918,41.918,0,0,0-12.293,12.026,67.65,67.65,0,0,0-6.6,12.3c11.19-33.033,30.5-54.873,52.472-54.873,34.6,0,62.654,54.141,62.654,120.927a228.476,228.476,0,0,1-2.076,30.946,194.522,194.522,0,0,1-6.218,29.146,150.9,150.9,0,0,1-8.351,21.967c-5.123,11.131-13.235,22.681-23.824,33.85-.657-.486-1.323-.971-1.971-1.457a171.689,171.689,0,0,1-20.2-17.72,117.82,117.82,0,0,0,14.521-18.044,72.365,72.365,0,0,0,5.27-9.664,122.47,122.47,0,0,0,6.875-18.539,172.093,172.093,0,0,0,5.266-26.423c.1-.771.181-1.552.267-2.323a201.033,201.033,0,0,0,1.181-21.729c0-19.425-2.457-39.849-9.112-58.2C267.144,144.149,258.964,129.067,246.919,122.421Z",
    transform: "translate(-80.865 -93.36)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M105.816,366.522c-1.6-2.895-.819-12.036,7.856-25.6,11.217-17.539,31.213-35.421,54.855-49.066a205.5,205.5,0,0,1,19.339-9.846c-5.332-21.948-6.218-29.146-6.218-29.146A228.4,228.4,0,0,0,153.882,266.5c-20.967,12.1-38.621,26.575-51.827,41.525C77.755,339.794,97.742,360.171,105.816,366.522Z",
    transform: "translate(-75.876 -100.987)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M219.329,340.593a203.907,203.907,0,0,1-18.158,11.845c-25.376,14.654-52.256,23.052-73.737,23.052-13.778,0-20.9-3.676-22.319-6.142l-.029-.057c-8.074-6.351-28.061-26.728-3.761-58.5-23.214,26.3-32.6,54.094-21.567,73.2,8.036,13.921,25.49,20.776,47.676,20.776,25.566,0,57.417-9.1,88.372-26.975a228.725,228.725,0,0,0,25.7-17.225,194.727,194.727,0,0,1-22.177-19.974Z",
    transform: "translate(-75.147 -103.757)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M326.3,291.851c23.643,13.645,43.629,31.536,54.855,49.066,8.684,13.578,9.455,22.719,7.855,25.6,8.065-6.342,28.061-26.709,3.8-58.464C379.6,293.085,361.931,278.6,340.945,266.49a228.72,228.72,0,0,0-27.785-13.645A194.512,194.512,0,0,1,306.94,282,207.032,207.032,0,0,1,326.3,291.851Z",
    transform: "translate(-86.23 -100.986)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M326.3,291.851c23.643,13.645,43.629,31.536,54.855,49.066,8.684,13.578,9.455,22.719,7.855,25.6,8.065-6.342,28.061-26.709,3.8-58.464C379.6,293.085,361.931,278.6,340.945,266.49a228.72,228.72,0,0,0-27.785-13.645A194.512,194.512,0,0,1,306.94,282,207.032,207.032,0,0,1,326.3,291.851Z",
    transform: "translate(-86.23 -100.986)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M256.955,239.241c-1.409-.124-2.847-.229-4.3-.286s-2.9-.1-4.38-.1H248.2c-1.485,0-2.942.038-4.38.1-1.466.067-2.9.162-4.3.286a149.319,149.319,0,0,0-23.49,3.733,286.438,286.438,0,0,0,5.532,28.756A115.568,115.568,0,0,1,245,268.216c1.085-.038,2.18-.076,3.237-.076s2.152.038,3.237.076a115.3,115.3,0,0,1,23.414,3.513,172.08,172.08,0,0,0,5.266-26.423c.1-.771.181-1.552.267-2.323a146.682,146.682,0,0,0-23.466-3.742Z",
    transform: "translate(-81.883 -100.317)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M386.922,301.718c24.262,31.755,4.266,52.122-3.8,58.464l-.029.057c-1.428,2.466-8.541,6.142-22.319,6.142-21.481,0-48.352-8.408-73.737-23.052a200.5,200.5,0,0,1-18.158-11.845c-.657-.486-1.324-.971-1.971-1.457a171.7,171.7,0,0,1-20.205-17.72,117.808,117.808,0,0,1-14.521-18.044,72.611,72.611,0,0,1-5.151-9.408,121.354,121.354,0,0,1-7-18.8A285.849,285.849,0,0,1,214.5,237.3a201.165,201.165,0,0,1-1.181-21.729c0-27.3,5.494-53.551,15.073-72.033,7.427-14.34,14.978-19.567,18.272-19.6-6.456-4.647-37.411-12.045-52.437,25.585-6.427,19-10.188,41.668-10.188,66.053a228.719,228.719,0,0,0,2.085,30.955s.886,7.2,6.218,29.146a149.1,149.1,0,0,0,8.522,22.3c5.132,11.026,13.2,22.453,23.671,33.517a194.718,194.718,0,0,0,22.176,19.977,229.879,229.879,0,0,0,25.69,17.225c30.965,17.872,62.816,26.975,88.372,26.975,22.186,0,39.639-6.856,47.676-20.777C419.477,355.783,410.117,328,386.922,301.718Z",
    transform: "translate(-80.354 -94.637)",
    fill: "url(#linear-gradient-7)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "market",
    d: "M141.057,103.969c0,9.736,5.926,14.6,17.355,14.6,11.852,0,17.566-4.868,17.566-14.6V41.958c0-23.916-17.99-35.979-54.392-35.979h-16.3c-13.33,0-24.547,4.021-33.859,11.852C62.114,10,50.686,5.979,37.564,5.979H21.479c-36.4,0-54.6,12.064-54.6,35.979v62.011c0,9.736,5.714,14.6,17.566,14.6,11.64,0,17.355-4.868,17.355-14.6V41.746c0-5.5,5.926-8.042,17.99-8.042H35.871c12.275,0,18.413,2.54,18.413,8.042v62.223q0,14.6,17.143,14.6t17.143-14.6V41.746c0-5.5,5.926-8.042,18.413-8.042h16.085c12.064,0,17.99,2.54,17.99,8.042Zm199.791,13.545c32.381,0,48.255-10.794,48.255-32.381V40.053c0-22.857-17.355-34.075-52.276-34.075H312.7c-10.582,0-15.873,4.445-15.873,13.122,0,8.889,5.291,13.122,15.873,13.122h24.127c12.275,0,18.413,2.751,18.413,8.042V44.92H272.065c-31.323,0-46.985,9.736-46.985,29.63V87.673q0,29.842,46.985,29.842Zm-2.963-26.455h-61.8c-11.217,0-16.931-2.328-16.931-6.984V73.7c0-4.445,5.714-6.984,16.931-6.984H355.24V83.863c0,4.868-5.926,7.2-17.354,7.2Zm105.187,12.91c0,9.524,5.714,14.6,17.355,14.6s17.566-4.868,17.566-14.6V41.746c0-5.5,6.773-8.042,20.318-8.042h13.545c11.217,0,16.72-4.656,16.72-13.968s-5.5-13.757-16.72-13.757H500c-37.884,0-56.932,12.064-56.932,36.191Zm237.04,9.1c8.677,4.233,11.429,5.5,17.566,5.5,12.064,0,18.2-4.868,18.2-14.18,0-4.868-1.9-9.524-12.275-14.392l-67.091-29.63L702.759,33.7c9.524-3.81,13.122-7.831,13.122-14.815,0-9.312-6.138-13.968-17.566-13.968-5.5,0-9.1,1.27-16.508,4.445l-70.69,30.48V-22.593c0-9.1-5.714-13.757-17.355-13.757S576.2-31.694,576.2-22.593V104.181c0,9.736,5.926,14.392,17.566,14.392s17.355-4.656,17.355-14.392V80.689ZM907.206,72.223c9.524,0,14.392-3.81,14.392-11.64V35.4c0-19.683-15.662-29.418-46.985-29.418h-63.7c-32.381,0-48.255,10.794-48.255,32.381V83.44c0,22.646,17.99,34.075,53.757,34.075H844.14c10.794,0,16.085-4.445,16.085-13.122,0-8.889-5.291-13.334-16.085-13.334H816.411c-13.333,0-19.894-2.54-19.894-7.831v-11ZM796.516,39.842q0-7.619,17.143-7.619H870.8c11.217,0,16.72,2.54,16.72,7.619v8.466c0,1.27-.635,1.9-2.116,1.9h-88.89Zm251.432-5.926c10.582,0,16.085-4.445,16.085-13.122,0-8.889-5.5-13.334-16.085-13.334h-29.63V-9.471c0-9.524-5.926-14.392-17.566-14.392S983.186-19,983.186-9.471V7.46h-3.81c-10.582,0-16.085,4.445-16.085,13.334,0,8.677,5.5,13.122,16.085,13.122h3.81V103.97q0,14.6,17.778,14.6c11.429,0,17.355-4.868,17.355-14.6V33.916Z",
    transform: "translate(-5557.77 3797.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crwd",
    d: "M-95.031,113.312c4.868,0,7.619-1.9,7.619-5.5s-2.751-5.5-7.619-5.5h-74.71c-25.4,0-38.1-6.984-38.1-20.741V47.491c0-13.757,12.7-20.741,38.1-20.741h74.71c4.868,0,7.619-1.9,7.619-5.5s-2.751-5.5-7.619-5.5h-74.71q-53.334,0-53.334,31.746V81.565q0,31.746,53.334,31.746Zm69.842-4.445c0,3.6,2.751,5.5,7.619,5.5s7.408-1.9,7.408-5.5v-61.8c0-13.545,12.91-20.318,38.1-20.318H47.4c4.656,0,7.2-1.9,7.2-5.5s-2.54-5.5-7.2-5.5H27.934c-35.344,0-53.122,10.582-53.122,31.746ZM209.947,14.686c-2.963,0-5.926,1.27-7.2,3.81l-41.27,77.25L121.057,18.5c-1.058-2.328-3.81-3.81-6.984-3.81-4.021,0-7.408,2.328-7.408,5.5a7.47,7.47,0,0,0,.635,2.963l47.62,87.2a7.007,7.007,0,0,0,6.773,4.021c2.963,0,5.714-1.058,7.2-3.81l41.059-76.192,41.27,76.192c1.482,2.751,3.81,3.81,6.984,3.81a7.309,7.309,0,0,0,6.984-4.021l47.408-87.2a5.042,5.042,0,0,0,.635-2.963c0-3.175-3.175-5.5-7.408-5.5-2.963,0-5.714,1.27-6.773,3.81L258.2,95.957,217.143,18.5a8.072,8.072,0,0,0-7.2-3.814Zm256.3,98.626c35.344,0,53.122-10.582,53.122-31.746V-29.547c0-3.6-2.54-5.5-7.408-5.5s-7.831,1.9-7.831,5.5V15.744H424.765q-53.334,0-53.334,31.746V81.565q0,31.746,53.334,31.746Zm.212-11H424.553c-25.186,0-37.884-6.984-37.884-20.741V47.491c0-13.757,12.7-20.741,37.884-20.741h79.578V81.565c0,13.757-12.7,20.741-37.672,20.741Z",
    transform: "translate(-6171.852 3797.244)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrwdmarketIconW);
export default __webpack_public_path__ + "static/media/crwdmarket_icon_w.bb65ecb6fe5cbe7ac7055e2af8f9e651.svg";
export { ForwardRef as ReactComponent };